export default __webpack_public_path__ + "static/media/glitch29.d3da38d4.png";